import React from 'react'
import useDeviceMetrics from '../../../utilities/useDeviceMetrics'
import InitialAssessmentTablet from '../initialAssessmentsTablet/InitialAssessmentsTablet.component'
import NeuroContent from '../neuro/content/Neuro.content'
import AirwayContent from '../airway/content/Airway.content'
import RespiratoryContent from '../respiratory/content/Respiratory.content'
import CardioContent from '../cardio/content/Cardio.content'
import { getInitialAssessmentSelector } from '../selectors'
import { useDispatch, useSelector } from 'react-redux'
import { IonContent, IonSplitPane, useIonViewDidEnter } from '@ionic/react'
import { InitialAssessmentConstants } from '../store/initialAssessment.constants'
import { setPrNabcDefaults } from '../store/initialAssessment.actions'

const AddAssessmentInfo: React.FC = () => {
  const dispatch = useDispatch()
  const { selectedOption, __areDefaultsSet } = useSelector(getInitialAssessmentSelector)
  const { isTablet } = useDeviceMetrics()

  const PageContent = () => (
    <>
      {selectedOption === InitialAssessmentConstants.NEURO && <NeuroContent />}
      {selectedOption === InitialAssessmentConstants.AIRWAY && <AirwayContent />}
      {selectedOption === InitialAssessmentConstants.RESPIRATORY && <RespiratoryContent />}
      {selectedOption === InitialAssessmentConstants.CARDIO && <CardioContent />}
    </>
  )

  useIonViewDidEnter(() => {
    if (!__areDefaultsSet) {
      dispatch(setPrNabcDefaults(true))
    }
  }, [__areDefaultsSet])

  return (
    <IonContent id='ia-main-content' color='light'>
      {isTablet ? (
        <IonSplitPane content-id='ia-main-content' className='no-scroll'>
          <InitialAssessmentTablet />
          <IonContent id='ia-main-content' color='light'>
            <PageContent />
          </IonContent>
        </IonSplitPane>
      ) : (
        <>
          <PageContent />
        </>
      )}
    </IonContent>
  )
}

export default AddAssessmentInfo
